














































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import midsummerDrainageApi from '@/app/model/api/midsummerDrainageApi'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    ErrorInfo
  }
})
export default class MidDrainageUpdateModal extends Vue {
  private startVariableDay: string = ''
  private endVariableDay: string = ''
  private errorMessage: string = ''
  private showStageUpdateDetail: boolean = false
  private show400ErrorMessage: boolean = false
  private alertText: string = ''
  private alertTitle: string = ''
  private midsummerDrainage: any = {}

  /* computed */
  private get showModal (): boolean {
    return this.$store.state.fieldDetailsState.midDrainageModalFlag
  }

  @Watch('showModal')
  onChangeModalFlag (val: any) {
    if (!val) {
      return
    }
    this.midsummerDrainage = JSON.parse(Session.getMidsummerDrainage()!)
    this.startVariableDay = this.addDate(this.midsummerDrainage.start_date ? this.midsummerDrainage.start_date : this.midsummerDrainage.goal_start_date, 0)
    this.endVariableDay = this.addDate(this.midsummerDrainage.end_date ? this.midsummerDrainage.end_date : this.midsummerDrainage.goal_end_date, 0)
    this.showStageUpdateDetail = this.midsummerDrainage.midsummer_drainage_histories.length > 0
  }

  private closeModal () {
    this.errorMessage = ''
    this.midsummerDrainage = {}
    this.show400ErrorMessage = false
    this.$store.commit('fieldDetailsState/setMidDrainageModalFlag', false)
  }

  private async updateMidsummerDrainage () {
    let plantingId = parseInt(Session.getPlantingId()!)

    const bodyData = {
      'planting_id': plantingId,
      'start_date': this.startVariableDay.replace(/-/g, ''),
      'end_date': this.endVariableDay.replace(/-/g, ''),
      'time_stamp': this.midsummerDrainage.time_stamp
    }

    const result = await midsummerDrainageApi.update(bodyData)

    if (result.isOk()) {
      this.show400ErrorMessage = false
      this.$emit('reacquire-stage-data')
      this.$store.commit('fieldDetailsState/setMidDrainageModalFlag', false)
    } else {
      this.alertText = ''
      this.alertTitle = '中干し実績日の更新に失敗しました。'
      this.show400ErrorMessage = true
    }
  }

  private rangeDateToStringMd (startDate: any, endDate: any) {
    return (startDate ? this.dateToStringMd(startDate) : '') + ' - ' + (endDate ? this.dateToStringMd(endDate) : '')
  }

  private dateToStringYmdHm (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate()) + ' ' + DateClass.toDoubleDigits(updateDate.getHours()) + ':' + DateClass.toDoubleDigits(updateDate.getMinutes())
      return formingDate
    }
  }

  private dateToStringYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate())
      return formingDate
    }
  }

  private dateToStringMd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate())
      return formingDate
    }
  }

  private addDate (date: string, add: number) {
    let newDate = new Date(new Date(date).getTime() + (add * 24 * 60 * 60 * 1000))
    return newDate.getFullYear() + '-' + DateClass.toDoubleDigits(newDate.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDate.getDate())
  }

  private nextStartDate () {
    if (this.startVariableDay === this.endVariableDay) {
      return
    }
    this.startVariableDay = this.addDate(this.startVariableDay, 1)
  }

  private prevStartDate () {
    this.startVariableDay = this.addDate(this.startVariableDay, -1)
  }

  private nextEndDate () {
    this.endVariableDay = this.addDate(this.endVariableDay, 1)
  }

  private prevEndDate () {
    if (this.startVariableDay === this.endVariableDay) {
      return
    }
    this.endVariableDay = this.addDate(this.endVariableDay, -1)
  }
}
